import React from 'react'

const ApplyForLoan = () => {
  return (
    <div>

       <section className="welcome_area apply-for-loan" id="home">
  <div className="container">
    <div className="row align-items-center">
       
      <div className="col-12 col-lg-6 col-md-12">
        <div className="welcome-content">
          
          <div className="promo-section">
            <div className="integration-link">
              <div className="integration-icon">
                <p className="badge">Apply For Loan</p>
              </div>
              <span className="integration-text">
                Quick approval • Minimal documentation • Fast disbursal
              </span>
            </div>
          </div>

          <h1 className="b-text bold">
            Get the Financial Support You Need with Me Loans
          </h1>

          <p>
            Apply online in just a few simple steps. Me Loans offers fast,
            flexible, and transparent loan solutions tailored to your needs. 
          </p>

          <div className="dream-btn-group fadeInUp" data-wow-delay="0.4s">
            <a href="/contact-us" className="btn more-btn mr-3">
              Contact Us
            </a>
            <a className="btn more-btn" href="#loan-form">
              Start Application
            </a>
          </div>

        </div>
      </div>

      <div className="col-lg-6">
        {/* Optional: Add image or illustration here */}
      </div>

    </div>
  </div>
</section>


      <div className="container py-5">
      <div className="row">

        {/* LEFT SIDE FORM */}
        <div className="col-lg-8">

          {/* Loan Details */}
          <h4 className="fw-bold mb-4 text-info">Loan Details:-</h4>

          <div className="row mb-4">
            <div className="col-md-4 mb-3">
              <input type="number" className="form-control" placeholder="Loan Amount *" />
            </div>
            <div className="col-md-4 mb-3">
              <input type="number" className="form-control" placeholder="Monthly Income *" />
            </div>
            <div className="col-md-4 mb-3">
              <select className="form-select">
                <option>Purpose of Loan *</option>
                <option>Personal Loan</option>
                <option>Business Loan</option>
                <option>Home Loan</option>
                <option>Car Loan</option>
              </select>
            </div>
          </div>

          {/* Personal Details */}
          <h4 className="fw-bold mb-4 text-info">Personal Details:-</h4>

          <div className="row">
            <div className="col-md-4 mb-3">
              <input type="text" className="form-control" placeholder="Name (As Per PAN Card) *" />
            </div>
            <div className="col-md-4 mb-3">
              <input type="email" className="form-control" placeholder="Email *" />
            </div>
            <div className="col-md-4 mb-3">
              <input type="text" className="form-control" placeholder="Mobile Number *" />
            </div>

            <div className="col-md-4 mb-3">
              <input type="date" className="form-control" />
            </div>
            <div className="col-md-4 mb-3">
              <input type="text" className="form-control" placeholder="PAN Card *" />
            </div>
            <div className="col-md-4 mb-3">
              <input type="text" className="form-control" placeholder="Aadhaar Number *" />
            </div>

            <div className="col-md-3 mb-3">
              <select className="form-select">
                <option>Select Gender *</option>
                <option>Male</option>
                <option>Female</option>
                <option>Other</option>
              </select>
            </div>

            <div className="col-md-3 mb-3">
              <select className="form-select">
                <option>State *</option>
                <option>Telangana</option>
                <option>Maharashtra</option>
                <option>Delhi</option>
              </select>
            </div>

            <div className="col-md-3 mb-3">
              <select className="form-select">
                <option>City *</option>
                <option>Hyderabad</option>
                <option>Mumbai</option>
                <option>Delhi</option>
              </select>
            </div>

            <div className="col-md-3 mb-3">
              <input type="text" className="form-control" placeholder="Pin Code *" />
            </div>
          </div>

          {/* Consent */}
          <div className="form-check my-4">
            <input className="form-check-input" type="checkbox" />
            <label className="form-check-label small">
              I hereby give my consent and authorize Me Loans and its service
              provider to obtain my Credit Information Report and Credit Score
              for risk assessment and underwriting purposes. I agree to the
              Terms & Conditions and Privacy Policy.
            </label>
          </div>

          <button className="btn btn-info text-white px-5 py-2">
            Submit
          </button>
        </div>

        {/* RIGHT SIDE CARDS */}
        <div className="col-lg-4 mt-4 mt-lg-0">

          {/* Eligibility Card */}
          <div className="card text-white mb-4 border-0 shadow"
               style={{background: "linear-gradient(rgb(23, 162, 184), rgb(169 224 233)) center center / cover"}}>
            <div className="card-body">
              <h5 className="fw-bold mb-3">Eligibility Criteria</h5>
              <p><strong>Resident:</strong> Indian</p>
              <p><strong>Age:</strong> 21 to 55 Years</p>
              <p><strong>Employment:</strong> Salaried Employee Only</p>
              <p><strong>CIBIL Score:</strong> 650 or Above</p>
              <p><strong>Monthly Salary:</strong> ₹35,000 or Above</p>
            </div>
          </div>

          {/* Rates Card */}
          <div className="card text-white border-0 shadow"
               style={{background: "linear-gradient(rgb(23, 162, 184), rgb(169 224 233)) center center / cover"}}>
            <div className="card-body">
              <h5 className="fw-bold mb-3">Our Rates & Fee</h5>
              <p><strong>Interest Rate:</strong> 9.9% p.a onwards</p>
              <p><strong>Pre-closure Charges:</strong> Nil</p>
              <p><strong>Loan Tenure:</strong> Up to 36 Months</p>
              <p><strong>APR:</strong> 10% to 36%</p>
              <p><strong>Cheque Bounce:</strong> ₹1000</p>
              <p><strong>Loan Amount:</strong> ₹5,000 - ₹1,00,000</p>
            </div>
          </div>

        </div>
      </div>
    </div>
      
    </div>
  )
}

export default ApplyForLoan
